module.exports = __webpack_public_path__ + "img/noassessment.9e67088c.svg";